import { render, staticRenderFns } from "./FormularioCliente.vue?vue&type=template&id=5ee3ce06&scoped=true&"
import script from "./FormularioCliente.vue?vue&type=script&lang=js&"
export * from "./FormularioCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3ce06",
  null
  
)

export default component.exports